import React from 'react';
import UserInputForm from './UserInputForm';
import BasicValues from './BasicValues';
import InfrastructureOptions from './InfrastructureOptions';
import { text } from '../../src/messages/codeMessages';

const ToolResults = (props) => {

  let userInput = [];
  let name = "";
  
  if(props.id === 'bandwidth') {
    userInput = {id: 'bandwidth', title: text.bandwidth.labelQuestion, name: "Amount TB per Month"};
    name = 'Outbound Data Transfer Bandwidth';

  } else if(props.id === 'block') {
    userInput = {id: 'block', title: text.blockStorage.labelQuestion, name: "Amount TB of Block Volume"};
    name = 'High Performance Block Volume';

  } else if(props.id === 'hpc') {
    userInput = {id: 'hpc', title: text.hpc.labelQuestion, name: "Instances"};
    name = 'CPUs';

  } else if(props.id === 'own') {
    userInput = {id: 'own', title: "Enter your estimates for your application below to get started"}
  }

  return (
    <div>
      <UserInputForm items = {userInput} state = {props.state}/>
      {props.state.show === true &&
      <div>
        <BasicValues name = {name} state={props.state}/>
        {(props.state.category === 'own' || props.state.category === 'hpc') ? <></> :
        <InfrastructureOptions state = {props.state}/>}
      </div>
      }
    </div>
  )
};
export default ToolResults;